// namespace
export const MUSIC_NAMESPACE = 'music'

// getters
export const MUSIC_LIST_GETTER = 'musics'
export const MUSIC_GETTER_MUSIC_BY_ID = 'getMusicById'

// mutations
export const MUSIC_MUTATION_ENTIRE_MUSIC = 'updateEntireMusics'
export const MUSIC_MUTATION_SINGLE_MUSIC_ATTRIBUTE = 'updateSingleMusicAttribute'
export const MUSIC_MUTATION_DELETE_MUSIC = 'deleteSingleMusic'
export const MUSIC_MUTATION_ADD_MUSIC = 'addMusic'

// actions
export const MUSIC_ACTION_GET_MUSICS = 'fetchMusics'
export const MUSIC_ACTION_CREATE_MUSIC = 'createMusic'
export const MUSIC_ACTION_DELETE_MUSIC = 'deleteMusic'
export const MUSIC_ACTION_UPDATE_MUSIC = 'updateMusic'

// types
export const MUSIC_TYPE_CEREMONY_MUSICS = 'ceremonyMusics'
export const MUSIC_TYPE_CEREMONY_BANDS = 'ceremonyBands'
export const MUSIC_TYPE_OBSERVANCE_MUSICS = 'observanceMusics'
export const MUSIC_TYPE_OBSERVANCE_BANDS = 'observanceBands'
export const MUSIC_TYPE_OTHER = 'otherType'



// WEBPACK FOOTER //
// ./src/store/modules/music-types.js